import React from "react";
import Experience from "../../components/Experience/Experience";

export default function StickyCardsPage() {
  return (
    <div className="experience-route stitch-navbar-offset">
      <Experience />
    </div>
  );
}
